export default __webpack_public_path__ + "static/media/impact.0dffdfc8.svg";